import { render, staticRenderFns } from "./InquiryDetails.vue?vue&type=template&id=5588044e&scoped=true&"
import script from "./InquiryDetails.vue?vue&type=script&lang=js&"
export * from "./InquiryDetails.vue?vue&type=script&lang=js&"
import style0 from "./InquiryDetails.vue?vue&type=style&index=0&id=5588044e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5588044e",
  null
  
)

export default component.exports